import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

const fragments = {
	IS_SELECTED_BRANCH: 'input[name="frm.isSelectedBranch"]',
	BRANCH_INPUT: 'input[name="frm.branch"]',
	BRANCH_INPUT_CHECKED: 'input[name="frm.branch"]:checked',
};

class OrderBranches extends WebComponent {
	constructor(props) {
		super(props);
		const {} = props;
	}

	didMount() {
		const {} = this.props;
		this.isSelectedBranchElement = document.querySelector(fragments.IS_SELECTED_BRANCH);
		/* predvyber položky pokud je pouze jedna*/
		this.branchInputElement = this.element.querySelectorAll(fragments.BRANCH_INPUT);
		if (this.branchInputElement.length === 1) {
			this.branchInputElement[0].click();
		}
		this.isAnyBranchSelected();
		this.on('change', fragments.BRANCH_INPUT, this.isAnyBranchSelected);
	}

	isAnyBranchSelected = () => {
		if(this.element.querySelectorAll(fragments.BRANCH_INPUT_CHECKED).length > 0) {
			if(!this.isSelectedBranchElement.checked) {
				this.isSelectedBranchElement.click();
			}
		} else {
			if(this.isSelectedBranchElement.checked) {
				this.isSelectedBranchElement.click();
			}
		}
	}
}

export default OrderBranches;



// WEBPACK FOOTER //
// ./config/module-publish/resources/js/components/Orders/OrderBranches.js